// removed by extract-text-webpack-plugin
module.exports = {"album":"_24v4r","cover":"_1nQTl","coverLoaded":"_2J16o _1nQTl","title":"_15r4j","name":"_3TFoa"};


//////////////////
// WEBPACK FOOTER
// ./src/components/home/FeaturedAlbum.css
// module id = 821
// module chunks = 0